// extracted by css-extract-rspack-plugin
export default {"root":"DashboardTodoListAllCompletedBanner_root__P3qMe"};